<template>
  <div class="wrapper">
    <div class="content">
      <div class="container">
        <div class="tips">一、引言</div>
        <div>
          深圳金箱科技有限公司（以下合称
          为“金箱科技”、“我们”或“我们的”）充分尊重并保护所有
          使用服务用户的个人隐私权。为了给您提供更准确、更有个
          性化的服务，金箱科技会按照本隐私权政策的规定使用和披
          露您的个人信息。但金箱科技将以高度的勤勉、审慎义务对
          待这些信息。除本隐私权政策另有规定外，在未征得您事先
          许可的情况下，金箱科技不会将这些信息对外披露或向第三
          方提供。金箱科技会不时更新本隐私权政策。 您在同意金箱
          科技服务使用协议之时，即视为您已经同意本隐私权政策全
          部内容。本隐私权政策属于金箱科技服务使用协议不可分割 的一部分。
        </div>
        <div class="smallTips">
          您使用或继续使用我们的服务，即意味着同意我们按照本
          《隐私政策》收集、使用、储存和分享您的相关信息。
        </div>
      </div>
      <div class="container">
        <div class="tips">二、适用范围</div>
        <div>
          1.在您注册金箱科技应用帐号时，您根据金箱科技要求提供的 个人注册信息；
        </div>
        <div>
          2.在您使用金箱科技网络服务，或访问金箱科技平台网页时，
          金箱科技自动接收并记录的您的浏览器和计算机上的信息，
          包括但不限于您的IP地址、浏览器的类型、使用的语言、
          访问日期和时间、软硬件特征信息及您需求的网页记录等 数据；
        </div>
        <div>3.金箱科技通过合法途径从商业伙伴处取得的用户个人数据。</div>
        <div class="smallTips">您了解并同意，以下信息不适用本隐私权政策</div>
        <div>1.您在使用金箱科技平台提供的搜索服务时输入的关键字信息；</div>
        <div>
          2.金箱科技收集到的您在金箱科技发布的有关信息数据，包
          括但不限于订单信息、合同信息及出入库管理信息；
        </div>
        <div>
          3.违反法律规定或违反金箱科技规则行为及金箱科技已对您 采取的措施
        </div>
      </div>
      <div class="container">
        <div class="tips">三、信息收集</div>
        <div class="smallTips">
          在您使用金箱科技各项业务功能的过程中，我们需要收集您的
          一些信息，用以向您提供服务、提升我们的服务质量。
        </div>
        <div>
          1.极光推送：为了快捷方便的及时消息通知，我们使用了极光
          推送SDK进行消息推送，在您登录之后会获取手机的设备ID，
          用以进行消息推送；
        </div>
        <div>
          2.百度地图：在进行作业的过程中，我们需要对您
          的位置进行实时定位，用于辨别是否在指定的区域进行
          作业，使用了百度地图SDK，仅用于位置信息的获取；
        </div>
        <div>
          3.友盟组件化基础库：为了更好的对服务质量进行提升，我们
          使用了友盟组件化基础库对用户操作行为、进行监控，以便
          于及时发现您使用过程中遇到的bug，并作出响应的修改；
        </div>
      </div>
      <div class="container">
        <div class="tips">四、信息使用</div>
        <div>
          1.金箱科技不会向任何无关第三方提供、出售、出租、分享或
          交易您的个人信息，除非事先得到您的许可，或该第三方和
          金箱科技（含金箱科技关联公司）单独或共同为您提供服务，且
          在该服务结束后，其将被禁止访问包括其以前能够访问的所有 这些资料；
        </div>
        <div>
          2.金箱科技亦不允许任何第三方以任何手段收集、编辑、出售
          或者无偿传播您的个人信息。任何金箱科技平台用户如从事上
          述活动，一经发现，金箱科技有权立即终止与该用户服务协议；
        </div>
        <div>
          3.为服务用户的目的，金箱科技可能通过使用您的个人信息，
          向您提供您感兴趣的信息，包括但不限于向您发出产品和
          服务信息，或者与金箱科技合作伙伴共享信息以便他们向您发
          送有关其产品和服务的信息（后者需要您的事先同意）。
        </div>
      </div>
      <div class="container">
        <div class="tips">五、信息披露</div>
        <div class="smallTips">
          在如下情况下，金箱科技将依据您的个人意愿或法律的规定全
          部或部分的披露您的个人信息：
        </div>
        <div>1.经您事先同意，向第三方披露；</div>
        <div>
          2.为提供您所要求的产品和服务，而必须和第三方分享您的 个人信息；
        </div>
        <div>
          3.根据法律的有关规定，或者行政或司法机构的要求，向第
          三方或者行政、司法机构披露；
        </div>
        <div>
          4.如您出现违反中国有关法律、法规或者金箱科技服务协议
          或相关规则的情况，需要向第三方披露；
        </div>
        <div>
          5.如您是适格的知识产权投诉人并已提起投诉，应被投诉人
          要求，向被投诉人披露，以便双方处理可能的权利纠纷；
        </div>
        <div>
          6.在金箱科技平台上创建的某一交易中，如交易任何一方履行
          或部分履行了交易义务并提出信息披露请求的，金箱科技有权
          决定向该用户提供其交易对方的联络方式等必要信息，以
          促成交易的完成或纠纷的解决；
        </div>
        <div>7.其它金箱科技根据法律、法规或者网站政策认为合适的披露。</div>
      </div>
      <div class="container">
        <div class="tips">六、信息存储和交换</div>
        <div class="smallTips">
          金箱科技收集的有关您的信息和资料将保存在金箱科技及
          （或）其关联公司的服务器上，这些信息和资料可能传送至
          您所在国家、地区或金箱科技收集信息和资料所在地的境外并
          在境外被访问、存储和展示。
        </div>
      </div>
      <div class="container">
        <div class="tips">七、Cookie的使用</div>
        <div>
          1.在您未拒绝接受cookies的情况下，金箱科技会在您的计算
          机上设定或取用cookies ，以便您能登录或使用依赖于cookies
          的金箱科技平台服务或功能。金箱科技使用cookies可为您提
          供更加周到的个性化服务，包括推广服务；
        </div>
        <div>
          2.您有权选择接受或拒绝接受cookies。您可以通过修改浏览
          器设置的方式拒绝接受cookies。但如果您选择拒绝接受
          cookies，则您可能无法登录或使用依赖于cookies的金箱科技
          网络服务或功能；
        </div>
        <div>3.通过金箱科技所设cookies所取得的信息，将适用本政策。</div>
      </div>
      <div class="container">
        <div class="tips">八、信息安全</div>
        <div class="smallTips">
          金箱科技帐号均有安全保护功能，请妥善保管您的用户名及
          密码信息。金箱科技将通过对用户密码进行加密等安全措施
          确保您的信息不丢失，不被滥用和变造。尽管有前述安全
          措施，但同时也请您注意在信息网络上不存在“完善的安全 措施”
        </div>
        <div class="smallTips">
          请您妥善保护自己的个人信息，仅在必要的情形下向他人
          提供。如您发现自己的个人信息泄密，尤其是金箱科技用户名
          及密码发生泄露，请您立即联络金箱科技客服，以便金箱科技 采取相应措施。
        </div>
      </div>
      <div class="container">
        <div class="tips">九、本隐私政策的更改</div>
        <div>
          1.如果决定更改隐私政策，我们会在本政策中、本公司网站
          中以及我们认为适当的位置发布这些更改，以便您了解我们
          如何收集、使用您的个人信息，哪些人可以访问这些信息，
          以及在什么情况下我们会透露这些信息；
        </div>
        <div>
          2.本公司保留随时修改本政策的权利，因此请经常查看。
          如对本政策作出重大更改，公司会通过网站通知的形式告知。
        </div>
      </div>
      <div class="documentName">
        文档名称：
        <div>金箱科技个人信息保护隐私政策</div>
      </div>
      <div class="updateDate">版本更新日期：2022-8-26</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "privacyAgreement",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
@import "./agreement.less";
.smallTips {
  font-weight: bold;
}
</style>
